import { render, staticRenderFns } from "./helpScore.vue?vue&type=template&id=0bf8232f&"
import script from "./helpScore.vue?vue&type=script&lang=js&"
export * from "./helpScore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bf8232f')) {
      api.createRecord('0bf8232f', component.options)
    } else {
      api.reload('0bf8232f', component.options)
    }
    module.hot.accept("./helpScore.vue?vue&type=template&id=0bf8232f&", function () {
      api.rerender('0bf8232f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/mdm/views/dealer_related_information_report/visitDetail/components/helpScore.vue"
export default component.exports